import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import moment from 'moment'
import ManagementDashboard from '@/pages/ManagementDashboard/ManagementDashboard.vue'
import tenancy from '@/plugins/tenancy'

const { user } = getModule(SystemtModule)

const rootCompanyId = process.env.VUE_APP_ROOT_COMPANY_ID

const now = moment()
const menus = [
  {
    title: 'Business Entities',
    icon: 'building',
    link: '/app/companies',
    index: 'companies',
    acl: {
      model: 'company',
      action: 'view',
    },
  },
  {
    title: 'Business Contacts',
    icon: 'address-card',
    link: '/app/company-contacts',
    index: 'company-contacts',
    acl: {
      model: 'company',
      action: 'view',
    },
  },
  {
    title: 'System Params',
    icon: 'cogs',
    link: '/app/system-parameters',
    index: 'system-parameters',
    acl: {
      model: 'system_config',
      action: 'view',
    },
  },
  {
    title: 'System Tools',
    icon: 'wrench',
    link: '/app/system-tools',
    index: 'system-tools',
    acl: {
      model: 'system_tools',
      action: 'view',
    },
  },
  {
    title: 'FAQs',
    icon: 'question-circle',
    link: '/app/faq-home',
    index: 'faq',
    acl: {
      model: 'faq',
      action: 'edit',
    },
  },

  {
    title: 'Profiles',
    icon: 'key',
    link: '/app/profiles',
    index: 'profiles',
    acl: {
      model: 'profile',
      action: 'view',
    },
  },
  {
    title: 'Users',
    icon: 'user',
    link: '/app/users',
    index: 'users',
    acl: {
      model: 'user',
      action: 'view',
    },
  },
  {
    title: 'Audit',
    icon: 'shield',
    link: '/app/audit',
    index: 'audit',
    acl: {
      model: 'audit',
      action: 'view',
    },
  },
  //   {
  //     title: 'Management',
  //     icon: 'building',
  //     index: 'tenants',
  //     children: [
  //       {
  //         title: 'Tenants',
  //         icon: 'building',
  //         link: '/app/tenants',
  //         acl: {
  //           model: 'tenant',
  //           action: 'view',
  //         },
  //       },
  //     ],
  //   },
  {
    title: 'Tenants',
    icon: 'building',
    link: '/app/tenants',
    acl: {
      model: 'tenant',
      action: 'view',
    },
  },
]

export default menus
